import { useAnimatedReaction } from "react-native-reanimated";

export type DependencyList = Parameters<typeof useAnimatedReaction>[2];
